import script from "./CardBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBoard.vue?vue&type=script&setup=true&lang=js"

import "./CardBoard.vue?vue&type=style&index=0&id=252bb9ce&lang=scss"

const __exports__ = script;

export default __exports__